import React from 'react';

import { VIEWER_ZONE_DOMAIN } from '../../../config/defaults';

import I18n from '../../../locales/i18n';
import sendToClipBoard from '../../../services/sendToClipboard';

import SettingsStreamControls from './Stream_Controls';
import RTMPData from './RTMPData';
import WEBRTCData from './WEBRTCData';

const View = ({
	url,
	statusClass,
	status,
	loadingDownStatus,
	countDownStatus,
	handleCountDownStatus,
	isBlocked,
	setStatus,
	startDate,
	videoServer,
	id,
	live_stream,
	_blockedMessage,
	primary_server,
	host_port,
	stream_name,
	username,
	password,
	encoderMethod,
	changeBroadcastMethod,
	organized,
	isEncoderLoading,
	encoder_rtmp,
	encoder_youtube,
	firebase,
	webrtc_users,
	updatePlayer,
}) => {
	return (
		<div className="row">
			<div className="col-md-12">
				<div className="alert alert-warning">
					Wow!. Estas a solo unos pasos de iniciar la transmisión de tu
					EventoVirtual y compartir tu Streaming en vivo con todos tus
					espectadores. Por favor ten en cuenta la siguiente información para
					configurar adecuadamente el software de codificación y no olvides
					consultar las ayudas en video que hemos preparado para ti.
				</div>
			</div>

			<div className="col-md-6 mg-b-20 row-eq-height">
				<div className="card card-body card-dashboard-twentyone ht-xl-100p d-flex justify-content-between flex-column">
					<div className="cnt-share-link">
						<div>
							<h6>
								La dirección para <span className="fup">compartir</span> con tus{' '}
								<span className="fup">espectadores</span> es:
							</h6>
							<h6>
								<a
									href={`${VIEWER_ZONE_DOMAIN}/${url}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									{VIEWER_ZONE_DOMAIN}/{url}
								</a>
							</h6>
						</div>
						<div>
							<button
								className="btn btn-outline-primary"
								onClick={() => {
									sendToClipBoard(
										`${VIEWER_ZONE_DOMAIN}/${url}`,
										'La dirección ha sido copiada'
									);
								}}
							>
								<i className="fas fa-copy"></i> Copiar
							</button>
							<button
								className="btn btn-outline-secondary"
								onClick={() => {
									var win = window.open(
										`${VIEWER_ZONE_DOMAIN}/${url}`,
										'_blank'
									);
									win.focus();
								}}
							>
								<i className="fas fa-external-link-alt"></i> Abrir
							</button>
						</div>
					</div>

					<div>
						<h6>Método de transmisión</h6>
						<div className="row ">
							<div
								className="col-md-6 row-eq-height"
								onClick={() => changeBroadcastMethod('other_rtmp')}
							>
								<div
									className={
										'btn-broadcast-method ht-xl-100p ' +
										(encoderMethod === 'other_rtmp'
											? 'btn-indigo'
											: 'btn-outline-primary')
									}
								>
									Transmitir desde mi Software (Wirecast, OBS, vMix, etc)
									(Encoder Externo)
								</div>
							</div>
							<div
								className="col-md-6 row-eq-height"
								onClick={() => changeBroadcastMethod('other_webrtc')}
							>
								<div
									className={
										'btn-broadcast-method ht-xl-100p ' +
										(encoderMethod === 'other_webrtc'
											? 'btn-indigo'
											: 'btn-outline-primary')
									}
								>
									Transmitir desde mi cámara web y compartir mi pantalla
									(Estudio de Transmisión Online [BETA])
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="col-sm-6 mg-b-20 row-eq-height">
				<div className="card card-body card-dashboard-twentyone ht-xl-100p">
					<h6 className="card-title tx-14 mg-b-10">Control del Stream</h6>
					<p className="mg-b-15">
						Aquí puedes "activar" y/o controlar tu transmisión,{' '}
						<strong>
							<i>si esto no ha iniciado, no podrás empezar a transmitir</i>
						</strong>
						.
					</p>
					<div className="event-settings-stream-actions">
						<div
							className={`alert alert-outline-${statusClass} mg-b-30`}
							role="alert"
						>
							<strong>Estado:</strong>{' '}
							{status.substr(-3) === 'ing' && (
								<i className="fas fa-spinner fa-spin"></i>
							)}
							{I18n('EVENT_SETTINGS_STATUSES', status)}
						</div>

						<button
							disabled={loadingDownStatus}
							className={
								'btn btn-' +
								(countDownStatus ? 'danger' : 'success') +
								' btn-countdown'
							}
							onClick={handleCountDownStatus}
						>
							{' '}
							{countDownStatus ? 'Desactivar' : 'Activar'} cuenta regresiva
						</button>

						<SettingsStreamControls
							status={status}
							isBlocked={isBlocked}
							setStatus={setStatus}
							startDate={startDate}
							videoServer={videoServer}
							id={id}
							live_stream={live_stream}
						/>
					</div>
					{isBlocked && (
						<div className="alert alert-warning mg-sm-t-10" role="alert">
							<strong>{_blockedMessage}!</strong>, por eso no puedes usar estos
							controles.
						</div>
					)}
				</div>
			</div>

			{isEncoderLoading && (
				<div className="col-md-12">
					<h1 className="text-center">
						<i className="fas fa-spinner fa-spin fa-3x" />
					</h1>
				</div>
			)}
			{encoderMethod === 'other_rtmp' && (
				<RTMPData
					primary_server={primary_server}
					host_port={host_port}
					stream_name={stream_name}
					encoder_rtmp={encoder_rtmp}
					username={username}
					password={password}
				/>
			)}

			{encoderMethod === 'other_webrtc' && (
				<WEBRTCData
					id={id}
					url={url}
					organized={organized}
					webrtc_users={webrtc_users}
					firebase={firebase}
				/>
			)}
		</div>
	);
};

export default View;
